
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/stazione-sciistica",
      function () {
        return require("private-next-pages/[region]/[resort]/stazione-sciistica.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/stazione-sciistica"])
      });
    }
  